import { StorageHelper } from '@aws-amplify/core'
import { env } from './env'

export const envs = {
  localstack: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_JpfMekx0U',
    userPoolWebClientId: '2p5o912trd0s3aukpdamoe3d2l',
    mandatorySignIn: true,
    storage: new StorageHelper().getStorage(),
    authenticationFlowType: 'USER_SRP_AUTH'
  }),
  development: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_0UOSdEdJZ',
    userPoolWebClientId: '7unp18f23694gjrg9t9cfeinph',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'dev.kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_SRP_AUTH'
  }),
  production: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_jp89gVS0l',
    userPoolWebClientId: 'm7ns5urlv4299lsua3j7lpriu',
    mandatorySignIn: true,
    storage: new StorageHelper().getStorage(),
    authenticationFlowType: 'USER_SRP_AUTH'
  }),
  live: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_jp89gVS0l',
    userPoolWebClientId: 'm7ns5urlv4299lsua3j7lpriu',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }),
  test: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_0UOSdEdJZ',
    userPoolWebClientId: '7unp18f23694gjrg9t9cfeinph',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'test.kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }),
  uat: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_0UOSdEdJZ',
    userPoolWebClientId: '7unp18f23694gjrg9t9cfeinph',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'uat.kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }),
  dev: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_0UOSdEdJZ',
    userPoolWebClientId: '7unp18f23694gjrg9t9cfeinph',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'dev.kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }),
  testlocal: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_0UOSdEdJZ',
    userPoolWebClientId: '7unp18f23694gjrg9t9cfeinph',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'local.kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  }),
  livelocal: () => ({
    region: 'eu-west-1',
    userPoolId: 'eu-west-1_jp89gVS0l',
    userPoolWebClientId: 'm7ns5urlv4299lsua3j7lpriu',
    mandatorySignIn: true,
    cookieStorage: {
      domain: 'local.kaiconversations.ai',
      path: '/',
      expires: 1,
      sameSite: 'strict',
      secure: true
    },
    authenticationFlowType: 'USER_PASSWORD_AUTH'
  })
}

export const cognitoConfig = envs[env]
